import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { GoogleOAuthProvider } from '@react-oauth/google';
import {
  Box, Flex, Button, Image, Avatar, Text, useColorMode, Stack, Grid, GridItem, Stat, StatLabel, StatNumber, Icon,
  useDisclosure, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, IconButton,
  SimpleGrid, Select, ButtonGroup, Badge, useColorModeValue, Alert, AlertIcon, AlertTitle, AlertDescription, Progress, Input, Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, FormControl, FormLabel, InputGroup, InputRightElement
} from "@chakra-ui/react";

import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine, Cell
} from 'recharts';

import { FaWalking, FaHeart, FaWeight, FaRulerVertical, FaHeartbeat, FaBars, FaFire, FaRoute, FaRunning, FaLock, FaDownload } from "react-icons/fa";
import { BiBarChart, BiLineChart } from 'react-icons/bi';

import Logo from "../fitness.png";
import Loading from "./Loader";
import GaugeChart from 'react-gauge-chart';
import { useNavigate } from "react-router-dom";
import { FaUtensils, FaDumbbell , FaBalanceScale } from "react-icons/fa";


import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import id from 'date-fns/locale/id';
registerLocale('id', id);


const HARDCODED_PASSWORD = 'Tcnsehat2024!';

const DashboardContent = ({ userEmail, setUserEmail }) => {

const { isOpen, onOpen, onClose } = useDisclosure();
  
const navigate = useNavigate();

const [mealVariant, setMealVariant] = useState(0);
 

  // 1. FUNGSI HELPER - taruh paling atas
  const parseDateString = (tglString) => {
    if (!tglString) return null;
    const tahun = new Date().getFullYear();
    const bulanMap = { Jan:0, Feb:1, Mar:2, Apr:3, Mei:4, Jun:5, Jul:6, Agu:7, Sep:8, Okt:9, Nov:10, Des:11 };
    const parts = tglString.split(', ')[1]?.split(' ');
    if (!parts) return null;
    const day = parseInt(parts[0]);
    const month = bulanMap[parts[1]];
    return new Date(tahun, month, day);
  };

  const formatDateString = (date) => {
    if (!date) return '';
    const hari = ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'];
    const bulan = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];
    return `${hari[date.getDay()]}, ${date.getDate()} ${bulan[date.getMonth()]}`;
  };

  const formatDateToMySQL = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // 2. STATE - sekarang aman pakai fungsi di atas
  const today = new Date();
  const [fitnessData, setFitnessData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [jumlahHari, setJumlahHari] = useState(7);
  const [chartType, setChartType] = useState('bar');
  const [mode, setMode] = useState('google');
  const { colorMode, toggleColorMode } = useColorMode();
  //const { isOpen, onOpen, onClose } = useDisclosure();
  //const handleLogout = () => window.location.reload();

const handleLogout = () => {
    // Kalau ada token, hapus dulu biar bener-bener logout
    sessionStorage.removeItem('googleFitToken');
    localStorage.removeItem('userEmail');
     setUserEmail(''); 
    navigate("/"); // <-- balik ke FirstPage
 };
  
  const cardBg = useColorModeValue("orange.50", "orange.300");

  const [selectedDateMYSQL, setSelectedDateMYSQL] = useState(formatDateToMySQL(today));
  const [selectedDate, setSelectedDate] = useState(formatDateString(today));

  const [bmi, setBmi] = useState(0);
  const [bmiCategory, setBmiCategory] = useState('');
  const [bmiColor, setBmiColor] = useState('#718096');
  const [latestWeight, setLatestWeight] = useState(0);
  const [latestHeight, setLatestHeight] = useState(0);
  
  const [selectedData, setSelectedData] = useState(null);
  const [mysqlData, setMysqlData] = useState(null);

  

  const { isOpen: isPasswordOpen, onOpen: onPasswordOpen, onClose: onPasswordClose } = useDisclosure();
  const [inputPassword, setInputPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [kirimLoading, setKirimLoading] = useState(false);
  const [kirimStatus, setKirimStatus] = useState('');

  const componentRef = useRef();

  // 3. DATA DERIVED
  const dataChart = fitnessData?.data || [];
  const tanggalAdaData = dataChart
   .map(d => parseDateString(d.tanggal)?.toDateString())
   .filter(Boolean);

  const minDate = new Date();
  minDate.setDate(today.getDate() - 90);

  const filterTanggal = (date) => {
    if (dataChart.length > 0) {
      return tanggalAdaData.includes(date.toDateString());
    }
    return date >= minDate && date <= today;
  };

  const handleGantiTanggalKalender = (date) => {
    const tglMYSQL = formatDateToMySQL(date);
    const tglDisplay = formatDateString(date);
    setSelectedDateMYSQL(tglMYSQL);
    setSelectedDate(tglDisplay);
    setSelectedData(dataChart.find(d => d.tanggal === tglDisplay) || null);
  };

  // sisanya tetap sama...










  // State modal password kirim data



  
  

  const fetchData = async (days) => {
    setIsLoading(true);
    const token = sessionStorage.getItem('googleFitToken');
    if (!token) {
      setIsLoading(false);
      alert('Silakan Connect Google Fit dulu');
      return;
    }
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE}/google-fit`, { token, days });
      setFitnessData(res.data);
      setBmi(res.data.bmi || 0);
      setBmiCategory(res.data.bmiCategory || '');
      setBmiColor(res.data.bmiColor || '#718096');
      setLatestWeight(res.data.latestWeight || 0);
      setLatestHeight(res.data.latestHeight || 0);
    } catch (err) {
      alert('Gagal refresh data');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGantiHari = (e) => {
    const hari = parseInt(e.target.value);
    setJumlahHari(hari);
   if (userEmail) {
    fetchHistoryFromDB(hari);
  }
  };



useEffect(() => {
  const fetchDataByDate = async () => {
    if (!userEmail ||!selectedDate) return;

    const dateMYSQL = formatDateToMySQL(parseDateString(selectedDate));

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/health-by-date`, {
        params: { email: userEmail, date: dateMYSQL }
      });
      setMysqlData(res.data);
    } catch (err) {
      console.error('Gagal ambil data MySQL:', err);
    }
  };

  fetchDataByDate();
}, [userEmail, selectedDate]);

useEffect(() => {
  const fetchDataByDate = async () => {
    if (!userEmail || !selectedDateMYSQL) return;

    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/health-by-date`, {
        params: { email: userEmail, date: selectedDateMYSQL } // kirim YYYY-MM-DD
      });
      setMysqlData(res.data);
    } catch (err) {
      console.error('Gagal ambil data MySQL:', err);
      setMysqlData(null);
    }
  };

  fetchDataByDate();
}, [userEmail, selectedDateMYSQL]); // <-- ganti ke selectedDateMYSQL

  useEffect(() => {
    if (dataChart.length > 0) {
      const last = dataChart[dataChart.length - 1];
      setSelectedDate(last.tanggal);
      setSelectedData(last);
    }
  }, [dataChart]);

  const getLastWeightHeight = (targetDate) => {
    if (!dataChart.length ||!targetDate) return { weight: latestWeight, height: latestHeight, tanggal: null };
    const validData = dataChart
     .filter(d => d.tanggal <= targetDate && d.weight > 0 && d.height > 0)
     .sort((a, b) => new Date(b.tanggal) - new Date(a.tanggal));
    if (validData.length > 0) {
      return {
        weight: validData[0].weight,
        height: validData[0].height,
        tanggal: validData[0].tanggal
      };
    }
    return { weight: latestWeight, height: latestHeight, tanggal: null };
  };

  const lastWeightHeight = getLastWeightHeight(selectedDate);
const displaySteps = mysqlData?.langkah ?? selectedData?.langkah ?? 0;
const displayHeartRate = mysqlData?.heart_rate ?? selectedData?.heart_rate ?? 0;
const displayCardio = mysqlData?.poin_kardio ?? selectedData?.poin_kardio ?? 0;
const displayWeight = mysqlData?.weight ?? selectedData?.weight ?? lastWeightHeight.weight ?? 0;
const displayHeight = mysqlData?.height ?? selectedData?.height ?? lastWeightHeight.height ?? 0;

  const calculateBmiByDate = () => {
    if (!displayWeight ||!displayHeight) return { bmi: 0, category: 'Tidak ada data', color: '#718096' };
    const bmiValue = displayWeight / ((displayHeight / 100) * (displayHeight / 100));
    let category = '';
    let color = '';
    if (bmiValue < 18.5) { category = 'Underweight'; color = '#3182CE'; }
    else if (bmiValue < 25) { category = 'Normal'; color = '#38A169'; }
    else if (bmiValue < 30) { category = 'Overweight'; color = '#ECC94B'; }
    else if (bmiValue < 35) { category = 'Obese I'; color = '#ED8936'; }
    else { category = 'Obese II'; color = '#E53E3E'; }
    return { bmi: bmiValue, category, color };
  };

  const displayBmiData = calculateBmiByDate();
  const displayBmi = displayBmiData.bmi;
  const displayBmiCategory = displayBmiData.category;
  const displayBmiColor = displayBmiData.color;

  const getHealthScoreByDate = () => {
  const data = mysqlData || selectedData;
  if (!data) return { label: 'Belum Ada Data', color: 'gray', persen: 0 };
      let skor = 0;
    const bmiValue = displayWeight && displayHeight? displayWeight / ((displayHeight / 100) * (displayHeight / 100)) : 0;
    if (bmiValue >= 18.5 && bmiValue < 25) skor += 20;
    else if (bmiValue >= 25 && bmiValue < 30) skor += 10;
if (data.langkah >= 10000) skor += 20;
  else if (data.langkah >= 7500) skor += 15;
  else if (data.langkah >= 5000) skor += 10;
  
  if (data.resting_heart_rate >= 60 && data.resting_heart_rate <= 100) skor += 20;
  else if (data.resting_heart_rate > 0) skor += 10;
  
  const jamTidur = (data.sleepMinutes || 0) / 60;
  if (jamTidur >= 7 && jamTidur <= 9) skor += 20;
  else if (jamTidur >= 6) skor += 10;
  
  if (data.menitAktif >= 22) skor += 20;
  else if (data.menitAktif >= 11) skor += 10;
  
  const persen = Math.round(skor);
  if (persen >= 80) return { label: 'Sangat Sehat', color: 'green', persen };
  if (persen >= 60) return { label: 'Sehat', color: 'teal', persen };
  if (persen >= 40) return { label: 'Cukup', color: 'orange', persen };
  return { label: 'Kurang Sehat', color: 'red', persen };
};

  const displayHealthScore = getHealthScoreByDate();

  const getHealthDetail = () => {
  const data = mysqlData || selectedData;
  if (!data) return [];

  const healthDetail = [  // <- ganti nama di sini
    {
      indikator: 'BMI',
      aktual: displayBmi >= 18.5 && displayBmi < 25 ? 100 : displayBmi >= 25 && displayBmi < 30 ? 50 : 0,
      target: 100,
      nilai: displayBmi ? displayBmi.toFixed(1) : '-',
      satuan: ''
    },
    {
      indikator: 'Langkah',
      aktual: Math.min(100, Math.round((data.langkah || 0) / 100)),
      target: 100,
      nilai: data.langkah || 0,
      satuan: ' langkah'
    },
    {
      indikator: 'RHR',
      aktual: data.resting_heart_rate >= 60 && data.resting_heart_rate <= 100 ? 100 : data.resting_heart_rate > 0 ? 50 : 0,
      target: 100,
      nilai: data.resting_heart_rate || '-',
      satuan: ' bpm'
    },
    {
      indikator: 'Tidur',
      aktual: Math.min(100, Math.round(((data.sleepMinutes || 0) / 60) / 8 * 100)),
      target: 100,
      nilai: data.sleepMinutes ? `${Math.floor(data.sleepMinutes/60)}j ${data.sleepMinutes%60}m` : '-',
      satuan: ''
    },
    {
      indikator: 'Kardio',
      aktual: Math.min(100, Math.round((data.menitAktif || 0) / 22 * 100)),
      target: 100,
      nilai: data.menitAktif || 0,
      satuan: ' poin'
    },
    {
      indikator: 'Oksigen',
      aktual: data.oxygen_saturation >= 95 ? 100 : data.oxygen_saturation >= 90 ? 70 : 0,
      target: 100,
      nilai: data.oxygen_saturation || '-',
      satuan: '%'
    }
  ];
  return healthDetail;  // <- return nama yang baru
};


  
  const healthDetail = getHealthDetail();
  
  // FUNGSI MODAL PASSWORD
  const handleOpenPasswordModal = () => {
    if (!dataChart.length) {
      alert('Data kosong. Connect Google Fit dulu.');
      return;
    }
    setInputPassword('');
    setPasswordError('');
    onPasswordOpen();
  };

  const handleSubmitPassword = async () => {
    if (!inputPassword) {
      setPasswordError('Password wajib diisi');
      return;
    }

    if (inputPassword!== HARDCODED_PASSWORD) {
      setPasswordError('Password salah!');
      return;
    }

    onPasswordClose();
    await kirimData7Hari();
  };

 const kirimData7Hari = async () => {
  if (!selectedDate || !selectedData) {
    return alert('Pilih tanggal dulu di kalender');
  }

  setKirimLoading(true);
  setKirimStatus('Mengirim data 7 hari...');

  const selectedIndex = dataChart.findIndex(d => d.tanggal === selectedDate);
  
  if (selectedIndex === -1) {
    setKirimLoading(false);
    return alert('Data tanggal yang dipilih tidak ada');
  }

  const startIndex = Math.max(0, selectedIndex - 6);
  const last7DaysFromSelected = dataChart.slice(startIndex, selectedIndex + 1);
  
  if (!last7DaysFromSelected.length) {
    setKirimLoading(false);
    return alert('Tidak ada data 7 hari ke belakang');
  }

  const calculateHealthScore = (data, weight, height) => {
    let skor = 0;
    const bmiValue = weight && height ? weight / ((height / 100) * (height / 100)) : 0;
    if (bmiValue >= 18.5 && bmiValue < 25) skor += 20;
    else if (bmiValue >= 25 && bmiValue < 30) skor += 10;
    if (data.langkah >= 10000) skor += 20;
    else if (data.langkah >= 7500) skor += 15;
    else if (data.langkah >= 5000) skor += 10;
    if (data.resting_heart_rate >= 60 && data.resting_heart_rate <= 100) skor += 20;
    else if (data.resting_heart_rate > 0) skor += 10;
    const jamTidur = (data.sleepMinutes || 0) / 60;
    if (jamTidur >= 7 && jamTidur <= 9) skor += 20;
    else if (jamTidur >= 6) skor += 10;
    if (data.menitAktif >= 22) skor += 20;
    else if (data.menitAktif >= 11) skor += 10;
    const persen = Math.round((skor / 100) * 100);
    let label = 'Kurang Sehat';
    if (persen >= 80) label = 'Sangat Sehat';
    else if (persen >= 60) label = 'Sehat';
    else if (persen >= 40) label = 'Cukup';
    return { persen, label };
  };

  const records = last7DaysFromSelected.map(d => {
    const weight = d.weight || getLastWeightHeight(d.tanggal).weight || 0;
    const height = d.height || getLastWeightHeight(d.tanggal).height || 0;
    
    let bmi = 0, bmiCategory = '';
    if (weight > 0 && height > 0) {
      const heightM = height / 100;
      bmi = parseFloat((weight / (heightM * heightM)).toFixed(1));
      if (bmi < 18.5) bmiCategory = 'Underweight';
      else if (bmi < 25) bmiCategory = 'Normal';
      else if (bmi < 30) bmiCategory = 'Overweight';
      else if (bmi < 35) bmiCategory = 'Obese I';
      else bmiCategory = 'Obese II';
    }

    const { persen, label } = calculateHealthScore(d, weight, height);

    return {
      userEmail: userEmail,
      tanggal: formatDateToMySQL(parseDateString(d.tanggal)),
      energi: d.energi || 0,
      jarakKm: d.jarakKm || 0,
      menitBergerak: d.menitBergerak || 0,
      menitAktif: d.menitAktif || 0,
      langkah: d.step_count || 0,
      kaloriMasuk: d.calories_in || 0,
      kaloriKeluar: d.energi || 0,
      sleepMinutes: d.sleepMinutes || 0,
      weight: weight,
      tinggi_badan: height, // TAMBAH INI
      heart_rate: d.heart_rate || 0,
      water: d.water || 0,
      resting_heart_rate: d.resting_heart_rate || 0,
      oxygen_saturation: d.oxygen_saturation || 0,
      blood_glucose: d.blood_glucose || 0,
      bmi: bmi,
      bmiCategory: bmiCategory,
      healthScore: persen,
      healthLabel: label,
      raw_data: d
    };
  });

  try {
    const res = await axios.post(`${process.env.REACT_APP_API_BASE}/save-health-records-batch`,
      { records },
      { timeout: 30000 }
    );
    
    if (res.data.success) {
      setKirimStatus(`Sukses: ${records.length} hari terkirim`);
      alert(`Berhasil kirim data dari ${records[0].tanggal} sampai ${records[records.length-1].tanggal}\n${res.data.message}`);
    }
  } catch (err) {
    const msg = err.response?.data?.error || err.message;
    setKirimStatus(`Gagal: ${msg}`);
    alert(`Gagal kirim: ${msg}`);
  } finally {
    setKirimLoading(false);
    setInputPassword('');
  }
};




  const ChartCard = ({ title, dataKey, name, unit = '', icon }) => (
    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container" >
      <Flex justify="space-between" align="center" mb={3}>
        <Box>
          <Text fontWeight="bold">{title}</Text>
          <Text fontSize="xs" color="gray.500">{jumlahHari} hari terakhir</Text>
        </Box>
        <Icon as={icon} boxSize={6} color="blue.500" />
      </Flex>
      <ResponsiveContainer width="100%" height={250}>
        {chartType === 'bar'? (
          <BarChart data={historyData}>
            <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
            <XAxis dataKey="tanggal" fontSize={11} />
            <YAxis />
            <Tooltip formatter={(v) => `${v} ${unit}`} />
            <Bar dataKey={dataKey} fill="#3182CE" name={name} radius={[4, 4, 0, 0]} />
          </BarChart>
        ) : (
          <LineChart data={historyData}>
            <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
            <XAxis dataKey="tanggal" fontSize={11} />
            <YAxis />
            <Tooltip formatter={(v) => `${v} ${unit}`} />
            <Line type="monotone" dataKey={dataKey} stroke="#3182CE" strokeWidth={3} dot={{ r: 3 }} name={name} />
          </LineChart>
        )}
      </ResponsiveContainer>
    </GridItem>
  );

  // TAROK SEBELUM return ( DI DALAM DashboardContent YG PERTAMA
const [historyData, setHistoryData] = useState([]);
const [historyLoading, setHistoryLoading] = useState(false);
 const { isOpen: isLoginOpen, onOpen: onLoginOpen, onClose: onLoginClose } = useDisclosure();
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [loginLoading, setLoginLoading] = useState(false);

  





const handleLoginMySQL = () => {
    if (!loginEmail || !loginPassword) {
      setLoginError('Email dan password wajib diisi');
      return;
    }
    if (loginPassword !== HARDCODED_PASSWORD) {
      setLoginError('Password salah!');
      return;
    }
    setUserEmail(loginEmail);
    sessionStorage.setItem('userEmail', loginEmail);
    fetchHistoryFromDB(jumlahHari);
    onLoginClose();
    setLoginEmail('');
    setLoginPassword('');
    setLoginError('');
  };
// FUNGSI AMBIL HISTORY DARI MYSQL
const fetchHistoryFromDB = async (days) => {
  if (!userEmail) return;
  setHistoryLoading(true);
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_BASE}/health-history`, {
      params: { email: userEmail, days: days }
    });
    
    // AMBIL res.data BUKAN res.data
    const cleanData = (res.data?.data || []).map(d => ({...d}));
    
    console.log('Data dari DB:', cleanData);
    setHistoryData(cleanData);
  } catch (err) {
    console.error('Gagal ambil history:', err);
    setHistoryData([]); // biar gak undefined
  } finally {
    setHistoryLoading(false);
  }
};

// State saran
const generateSuggestion = (variant = 0) => {
  const weight = displayWeight || 0;const age = mysqlData?.umur?? selectedData?.umur?? 25;
const gender = mysqlData?.jenis_kelamin?? selectedData?.jenis_kelamin?? 'wanita';
  const height = displayHeight || 0;
  const steps = displaySteps || 0;

  
  const genderNormalized = (gender || 'wanita').toLowerCase();
  const isPria = genderNormalized === 'pria';

  if (!weight ||!height) return null;

  const heightM = height / 100;
  const bmi = weight / (heightM * heightM);

  let kategori = 'normal';
  if (bmi < 18.5) kategori = 'underweight';
  else if (bmi >= 25) kategori = 'overweight';

  // BMR Mifflin-St Jeor
  let bmr = isPria? 10*weight + 6.25*height - 5*age + 5 : 10*weight + 6.25*height - 5*age - 161;

  // Activity multiplier
  let aktivitasMultiplier = 1.375; // default light active
  if (steps >= 12500) aktivitasMultiplier = 1.725;
  else if (steps >= 10000) aktivitasMultiplier = 1.55;
  else if (steps >= 7500) aktivitasMultiplier = 1.55;

  let tdee = Math.round(bmr * aktivitasMultiplier);
  let targetKalori = tdee;
  let targetKaloriText = 'Maintain';

  if (kategori === 'underweight') {
    targetKalori = tdee + 400;
    targetKaloriText = 'Naik Berat +400';
  } else if (kategori === 'overweight') {
    targetKalori = tdee - 500;
    targetKaloriText = 'Turun Berat -500';
  }

  // Makro: protein lebih tinggi kalau diet
  let proteinPersen = kategori === 'overweight'? 0.35 : 0.25;
  const protein = Math.round((targetKalori * proteinPersen) / 4);
  const sisaKalori = targetKalori - (protein * 4);
  const lemak = Math.round((sisaKalori * 0.25) / 9);
  const karbo = Math.round((sisaKalori * 0.75) / 4);

  // 3 VARIASI MEAL PLAN - HANYA 1X DEKLARASI
  const mealPlans = {
    normal: [
      [ // Variasi 1 - Indo
        { waktu: 'Sarapan', menu: 'Oatmeal 50g + pisang 1 buah + telur rebus 2 butir', kkal: 420 },
        { waktu: 'Snack Pagi', menu: 'Apel 1 buah + kacang almond 15g', kkal: 180 },
        { waktu: 'Makan Siang', menu: 'Nasi merah 150g + ayam panggang 120g + sayur tumis 200g', kkal: 580 },
        { waktu: 'Snack Sore', menu: 'Yoghurt Greek 150g', kkal: 120 },
        { waktu: 'Makan Malam', menu: 'Nasi 120g + ikan tongkol 120g + tumis kangkung 150g + tahu 100g', kkal: 500 }
      ],
      [ // Variasi 2 - Western
        { waktu: 'Sarapan', menu: 'Roti gandum 2 lembar + alpukat 50g + telur orak-arik 2 butir', kkal: 450 },
        { waktu: 'Snack Pagi', menu: 'Jeruk 1 buah + kacang tanah 20g', kkal: 180 },
        { waktu: 'Makan Siang', menu: 'Pasta gandum 150g + daging sapi 120g + salad sayur', kkal: 600 },
        { waktu: 'Snack Sore', menu: 'Susu low fat 200ml + biskuit gandum 2 keping', kkal: 150 },
        { waktu: 'Makan Malam', menu: 'Kentang rebus 200g + ikan salmon 120g + brokoli kukus', kkal: 480 }
      ],
      [ // Variasi 3 - Simple
        { waktu: 'Sarapan', menu: 'Sereal gandum 40g + susu low fat 250ml + pisang 1 buah', kkal: 380 },
        { waktu: 'Snack Pagi', menu: 'Yoghurt plain 150g', kkal: 120 },
        { waktu: 'Makan Siang', menu: 'Nasi 150g + tempe bacem 100g + tumis buncis 200g', kkal: 550 },
        { waktu: 'Snack Sore', menu: 'Telur rebus 2 butir', kkal: 140 },
        { waktu: 'Makan Malam', menu: 'Mie shirataki 150g + ayam suwir 100g + sayur sop', kkal: 420 }
      ]
    ],
    underweight: [
      [
        { waktu: 'Sarapan', menu: 'Nasi 200g + telur dadar 2 butir + alpukat 100g + susu full cream 300ml', kkal: 750 },
        { waktu: 'Snack Pagi', menu: 'Kacang mete 40g + pisang 1 buah', kkal: 300 },
        { waktu: 'Makan Siang', menu: 'Nasi 250g + ayam 150g + tempe 100g + sayur', kkal: 900 },
        { waktu: 'Snack Sore', menu: 'Yoghurt full fat 200g + granola 30g', kkal: 350 },
        { waktu: 'Makan Malam', menu: 'Nasi 200g + salmon 150g + kentang 150g', kkal: 500 }
      ],
      [
        { waktu: 'Sarapan', menu: 'Roti tawar 4 lembar + selai kacang 2 sdm + susu full cream 300ml', kkal: 680 },
        { waktu: 'Snack Pagi', menu: 'Smoothie pisang + madu + susu 300ml', kkal: 350 },
        { waktu: 'Makan Siang', menu: 'Nasi 300g + daging sapi 150g + kentang goreng 100g', kkal: 950 },
        { waktu: 'Snack Sore', menu: 'Es krim 1 scoop + kacang 30g', kkal: 280 },
        { waktu: 'Makan Malam', menu: 'Nasi 250g + ikan lele goreng 150g + tempe goreng 100g', kkal: 700 }
      ],
      [
        { waktu: 'Sarapan', menu: 'Bubur ayam 1 porsi + telur 1 butir + cakwe 1 potong', kkal: 600 },
        { waktu: 'Snack Pagi', menu: 'Kurma 5 biji + susu full cream 250ml', kkal: 280 },
        { waktu: 'Makan Siang', menu: 'Nasi 250g + ayam goreng 150g + perkedel kentang 2 buah', kkal: 850 },
        { waktu: 'Snack Sore', menu: 'Roti bakar keju 2 lembar', kkal: 320 },
        { waktu: 'Makan Malam', menu: 'Nasi 200g + rendang 120g + sayur nangka', kkal: 650 }
      ]
    ],
    overweight: [
      [
        { waktu: 'Sarapan', menu: 'Oatmeal 40g + telur rebus 2 butir', kkal: 280 },
        { waktu: 'Snack Pagi', menu: 'Apel 1 buah', kkal: 80 },
        { waktu: 'Makan Siang', menu: 'Nasi merah 100g + dada ayam 120g + sayur 200g', kkal: 420 },
        { waktu: 'Snack Sore', menu: 'Yoghurt plain 150g', kkal: 120 },
        { waktu: 'Makan Malam', menu: 'Tumis tahu 150g + brokoli 200g', kkal: 300 }
      ],
      [
        { waktu: 'Sarapan', menu: 'Telur dadar sayur 2 butir tanpa minyak', kkal: 160 },
        { waktu: 'Snack Pagi', menu: 'Timun 1 buah + wortel 1 buah', kkal: 50 },
        { waktu: 'Makan Siang', menu: 'Sup ayam bening 1 mangkok + dada ayam 100g + sayur 200g', kkal: 320 },
        { waktu: 'Snack Sore', menu: 'Alpukat 50g', kkal: 80 },
        { waktu: 'Makan Malam', menu: 'Salad tuna 150g + sayur rebus 200g', kkal: 280 }
      ],
      [
        { waktu: 'Sarapan', menu: 'Omelet putih telur 3 butir + bayam', kkal: 180 },
        { waktu: 'Snack Pagi', menu: 'Stroberi 100g', kkal: 40 },
        { waktu: 'Makan Siang', menu: 'Nasi shirataki 200g + ikan bakar 120g + tumis kangkung', kkal: 350 },
        { waktu: 'Snack Sore', menu: 'Kacang edamame 100g', kkal: 120 },
        { waktu: 'Makan Malam', menu: 'Sup sayur bening + tahu 150g', kkal: 200 }
      ]
    ]
  };

  // PINDAH KE BAWAH SETELAH mealPlans didefinisikan
  const selectedMealPlan = mealPlans[kategori][variant % 3];
  const totalKkal = selectedMealPlan.reduce((sum, m) => sum + m.kkal, 0);

  // Activity plan
  let activityPlan = [];
  if (steps < 5000) {
    activityPlan.push(`Langkah kamu ${steps}/hari. Target minggu depan 4500 langkah/hari. Tambah 1000/minggu.`);
  }

  if (kategori === 'underweight') {
    activityPlan.push(
      'Latihan beban 3x/minggu: squat, push up, pull up 3 set x 8-12 repetisi',
      'Kardio ringan 2x/minggu max 30 menit',
      'Target tidur 7-8 jam untuk recovery otot'
    );
  } else if (kategori === 'normal') {
    activityPlan.push(
      '150-300 menit jalan cepat/minggu. Bagi jadi 30 menit x 5 hari',
      'Latihan beban 2x/minggu: full body workout 40 menit',
      'Kurangi duduk. Bangun dan jalan 2 menit tiap 30 menit kerja'
    );
  } else {
    activityPlan.push(
      '300 menit aerobik sedang/minggu. Jalan cepat 60 menit x 5 hari',
      'Latihan beban 2x/minggu untuk jaga metabolisme',
      'Target 8000-10000 langkah/hari'
    );
  }

  return {
    kategori,
    bmi: bmi.toFixed(1),
    targetKalori,
    targetKaloriText, // TAMBAH INI
    makro: { protein, lemak, karbo },
    mealPlan: selectedMealPlan,
    activityPlan,
    totalKkal,
    variant
  };
};
  
const handleChangeMealVariant = async () => {
  const newVariant = (mealVariant + 1) % 3;
  setMealVariant(newVariant);

  // Save ke DB biar keinget
  if (userEmail) {
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE}/api/user-meal-variant`, {
        email: userEmail,
        meal_variant: newVariant
      });
    } catch (err) {
      console.error('Gagal save varian:', err);
    }
  }
};


const [prevKategori, setPrevKategori] = useState('');
const suggestion = generateSuggestion(mealVariant);

useEffect(() => {
  if (suggestion?.kategori && suggestion.kategori!== prevKategori) {
    setMealVariant(0);
    setPrevKategori(suggestion.kategori);

    // Save reset ke DB juga
    if (userEmail) {
      axios.post(`${process.env.REACT_APP_API_BASE}/api/user-meal-variant`, {
        email: userEmail,
        meal_variant: 0
      }).catch(console.error);
    }
  }
}, [suggestion?.kategori, prevKategori, userEmail]);


// PANGGIL SAAT LOGIN & GANTI HARI
useEffect(() => {
  if (userEmail) fetchHistoryFromDB(jumlahHari);
}, [userEmail, jumlahHari]);

  return (
    <>
      {isLoading? (
        <Loading />
      ) : (
   <Box>
          {/* HEADER RESPONSIF */}
<Box bg={colorMode === "light"? "black" : "pink.800"} px={{ base: 2, md: 4 }} py={2} color="white" position="sticky" top={0} zIndex={10}>
  <Flex align="center" justify="space-between" wrap="wrap" gap={2}>

    {/* Kiri: Hamburger + Logo */}
    <Flex align="center" flexShrink={0}>
      <IconButton
        display={{ base: "flex", md: "none" }}
        onClick={onOpen}
        icon={<Icon as={FaBars} />}
        variant="outline"
        colorScheme="whiteAlpha"
        size="sm"
        mr={2}
        aria-label="Menu"
      />
      <Image src={Logo} alt="Logo" boxSize={{ base: "28px", md: "40px" }} mr={2} />
      <Box>
        <Text fontSize={{ base: "sm", md: "lg" }} fontWeight="bold" lineHeight="1">Bugarin</Text>
        <Text fontSize={{ base: "xs", md: "sm" }} lineHeight="1">Tracker</Text>
      </Box>
    </Flex>

    {/* Kanan: Datepicker + Avatar+Email + Tombol */}
    <Flex align="center" gap={{ base: 1, md: 2 }} flexWrap="wrap" justify="flex-end" flex="1" minW={0}>

      {/* Datepicker - TETAP MUNCUL DI HP */}
      {userEmail && (
        <DatePicker
          selected={parseDateString(selectedDate)}
          onChange={handleGantiTanggalKalender}
          filterDate={filterTanggal}
          minDate={minDate}
          maxDate={today}
          dateFormat="E, d MMM"
          locale="id"
          customInput={
            <Input
              size="xs"
              bg="whiteAlpha.200"
              borderColor="whiteAlpha.300"
              color="white"
              w={{ base: "90px", sm: "110px", md: "160px" }}
              fontSize={{ base: "xs", md: "sm" }}
              _hover={{ bg: "whiteAlpha.300" }}
              cursor="pointer"
              readOnly
            />
          }
          popperPlacement="bottom-end"
        />
      )}

      {/* Avatar + Email - HILANG DI HP, MUNCUL DI LAPTOP */}
      <Flex align="center" gap={1} display={{ base: "none", md: "flex" }}>
        <Avatar size="xs" name={userEmail || "Guest"} />
        <Text fontSize="sm" fontWeight="bold" noOfLines={1} maxW="140px">
          {userEmail}
        </Text>
      </Flex>

      {/* Logout */}
      <Button size="xs" variant="outline" colorScheme="whiteAlpha" onClick={handleLogout}>
        Logout
      </Button>

      {/* Toggle Dark/Light */}
      <IconButton
        size="xs"
        icon={colorMode === "light"? "🌙" : "☀️"}
        variant="outline"
        colorScheme="whiteAlpha"
        onClick={toggleColorMode}
        aria-label="Toggle theme"
      />
    </Flex>
  </Flex>
</Box>
      <Flex direction={{ base: "column", md: "row" }}>
             {/* SIDEBAR DESKTOP */}
             <Box
               w={{ md: "220px" }}
               h="100vh"
               p={4}
               bg={colorMode === "light"? "gray.100" : "gray.700"}
               display={{ base: "none", md: "block" }}
               position="sticky"
               top="56px"
               className="no-print"
             >
              <Stack spacing={7}>
                <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold">Home</Text>
                <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold">About Us</Text>
                <Text cursor="pointer" color={colorMode === "light"? "teal.500" : "white"} fontWeight="bold">Contacts</Text>
 
<Button colorScheme="blue" variant="solid" size="sm" onClick={onLoginOpen}>
  Login Bugarin Tracker
</Button>


<Button
    onClick={() => {
      // Scroll ke card meal plan
      navigate("/dashboard-meal")
    }}
    leftIcon={<Icon as={FaUtensils} />}
    colorScheme="orange"
    variant={userEmail ? "solid" : "outline"}
    w="full"
    isDisabled={!userEmail}
    opacity={userEmail ? 1 : 0.5}
  >
    Meal Plan
  </Button>

  <Button
onClick={() => {
      // Scroll ke card meal plan
      navigate("/dashboard-meal-real")
    }}
    leftIcon={<Icon as={FaBalanceScale} />}
    colorScheme="teal"
    variant={userEmail ? "solid" : "outline"}
    w="full"
    isDisabled={!userEmail}
    opacity={userEmail ? 1 : 0.5}
  >
    Meal Plan vs Real
  </Button>

  <Button
   onClick={() => {
      // Scroll ke card meal plan
      navigate("/dashboard-master")
    }}
    leftIcon={<Icon as={FaBalanceScale} />}
    colorScheme="teal"
    variant={userEmail ? "solid" : "outline"}
    w="full"
    isDisabled={!userEmail}
    opacity={userEmail ? 1 : 0.5}
  >
    Master Data
  </Button>
               
                <Button
                  colorScheme="red"
                  variant="solid"
                  size="sm"
                  onClick={() => {
                    if (!fitnessData) {
  
                    }
                    const printStyle = `
                      <style>
                        @page { size: A4; margin: 10mm; }
                        @media print {
                          * {
                            -webkit-print-color-adjust: exact!important;
                            color-adjust: exact!important;
                            print-color-adjust: exact!important;
                          }
                          body { background: white!important; }
                         .no-print { display: none!important; }
                         .chart-container { page-break-inside: avoid!important; }
                         .recharts-wrapper { page-break-inside: avoid!important; }
                          [class*="chakra"] {
                            -webkit-print-color-adjust: exact!important;
                          }
                        }
                      </style>
                    `;
                    const originalContents = document.body.innerHTML;
                    const printContents = printStyle + componentRef.current.innerHTML;
                    document.body.innerHTML = printContents;
                    window.print();
                    document.body.innerHTML = originalContents;
                    window.location.reload();
                  }}
                  leftIcon={<Icon as={FaDownload} />}
                >
                  Download PDF
                </Button>
              </Stack>
            </Box>
     <Box>
          {/* Header, Sidebar, Konten utama kamu semua di sini */}
          
          {/* Modal Login TARUH DI SINI */}
          <Modal isOpen={isLoginOpen} onClose={onLoginClose} isCentered>
            <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
            <ModalContent>
              <ModalHeader>
                <Flex align="center" gap={2}>
                  <Icon as={FaLock} color="blue.500" />
                  <Text>Login Bugarin Tracker</Text>
                </Flex>
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Stack spacing={4}>
                  <FormControl isInvalid={!!loginError}>
                    <FormLabel>Email</FormLabel>
                    <Input
                      type="email"
                      placeholder="masukan@email.com"
                      value={loginEmail}
                      onChange={(e) => {
                        setLoginEmail(e.target.value);
                        setLoginError('');
                      }}
                    />
                  </FormControl>

                  <FormControl isInvalid={!!loginError}>
                    <FormLabel>Password</FormLabel>
                    <InputGroup>
                      <Input
                        type={showLoginPassword ? 'text' : 'password'}
                        placeholder="Password..."
                        value={loginPassword}
                        onChange={(e) => {
                          setLoginPassword(e.target.value);
                          setLoginError('');
                        }}
                        onKeyPress={(e) => e.key === 'Enter' && handleLoginMySQL()}
                      />
                      <InputRightElement width="4.5rem">
                        <Button h="1.75rem" size="sm" onClick={() => setShowLoginPassword(!showLoginPassword)}>
                          {showLoginPassword ? 'Hide' : 'Show'}
                        </Button>
                      </InputRightElement>
                    </InputGroup>
                    {loginError && <Text color="red.500" fontSize="sm" mt={1}>{loginError}</Text>}
                  </FormControl>
                </Stack>
              </ModalBody>

              <ModalFooter>
                <Button variant="ghost" mr={3} onClick={onLoginClose}>
                  Batal
                </Button>
                <Button colorScheme="blue" onClick={handleLoginMySQL} isLoading={loginLoading}>
                  Login
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>            

           <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
              <DrawerOverlay />
              <DrawerContent bg={colorMode === "light"? "gray.100" : "gray.700"}>
                <DrawerCloseButton />
                <DrawerHeader>Menu</DrawerHeader>
                <DrawerBody>
                  <Stack spacing={4}>
                    <Text fontWeight="bold">Home</Text>
                    <Text fontWeight="bold">About Us</Text>
                    <Text fontWeight="bold">Contacts</Text>
                    <Flex align="center" gap={2} py={2}>
                      <Avatar size="sm" name={userEmail || "Guest"} />
                      <Text fontSize="sm" noOfLines={1}>{userEmail}</Text>
                    </Flex>
                    <Button variant="outline" onClick={toggleColorMode}>
                      {colorMode === "light"? "Dark Mode" : "Light Mode"}
                    </Button>
                  </Stack>
                </DrawerBody>
              </DrawerContent>
            </Drawer>

            <Flex direction="column" w={{ base: "100%", md: "80%" }} p={4} ref={componentRef}>
     {historyData.length > 0 ? (
                <Stack spacing={6}>
                  <Flex justify="space-between" align="center" wrap="wrap" gap={4}>
                    <Text fontSize="2xl" fontWeight="bold">Ringkasan Aktivitas</Text>
                    <Flex gap={3}>
                      <ButtonGroup size="sm" isAttached variant="outline">
                        <IconButton icon={<BiBarChart />} onClick={() => setChartType('bar')} colorScheme={chartType === 'bar'? 'blue' : 'gray'} aria-label="Bar" />
                        <IconButton icon={<BiLineChart />} onClick={() => setChartType('line')} colorScheme={chartType === 'line'? 'blue' : 'gray'} aria-label="Line" />
                      </ButtonGroup>
                      <Select value={jumlahHari} onChange={handleGantiHari} w="180px" bg="white" isDisabled={isLoading}>
                        <option value={7}>7 hari terakhir</option>
                        <option value={14}>14 hari terakhir</option>
                        <option value={30}>30 hari terakhir</option>
                        <option value={90}>90 hari terakhir</option>
                        <option value={150}>150 hari terakhir</option>
                      </Select>
                    </Flex>
                  </Flex>

                  <Grid templateColumns={{ base: "1fr", sm: "1fr 1fr", lg: "repeat(5, 1fr)" }} gap={4}>
                    <GridItem bgGradient="linear(to-br, blue.400, blue.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>
                            Langkah
                            <Text as="span" display="block" fontSize="xs" opacity={0.8} mt={0.5}>
                              {selectedDate}
                            </Text>
                          </StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displaySteps}</StatNumber>
                        </Stat>
                        <Icon as={FaWalking} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, teal.400, teal.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>
                            Poin Kardio
                            <Text as="span" display="block" fontSize="xs" opacity={0.8} mt={0.5}>
                              {selectedDate}
                            </Text>
                          </StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayCardio}</StatNumber>
                        </Stat>
                        <Icon as={FaHeart} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, purple.400, purple.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>Berat Badan</StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayWeight} <Text as="span" fontSize="lg">kg</Text></StatNumber>
                        </Stat>
                        <Icon as={FaWeight} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, orange.400, orange.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>Tinggi Badan</StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayHeight} <Text as="span" fontSize="lg">cm</Text></StatNumber>
                        </Stat>
                        <Icon as={FaRulerVertical} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>

                    <GridItem bgGradient="linear(to-br, pink.400, pink.600)" p={4} rounded="xl" shadow="lg" color="white" className="chart-container">
                      <Flex justify="space-between" align="start">
                        <Stat>
                          <StatLabel fontSize="sm" opacity={0.9}>Detak Jantung</StatLabel>
                          <StatNumber fontSize={{ base: "2xl", md: "3xl" }} fontWeight="bold">{displayHeartRate} <Text as="span" fontSize="lg">bpm</Text></StatNumber>
                        </Stat>
                        <Icon as={FaHeartbeat} boxSize={{ base: 6, md: 8 }} opacity={0.8} />
                      </Flex>
                    </GridItem>
                  </Grid>

                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} className="chart-container">
                      <Text fontWeight="bold" mb={3} textAlign="center" fontSize={{ base: "md", md: "lg" }}>
                        Body Mass Index - {selectedDate}
                      </Text>
                      <Box w="100%" maxW={{ base: "300px", sm: "350px", md: "400px" }} mx="auto">
                        <GaugeChart
                          id="bmi-gauge"
                          nrOfLevels={5}
                          colors={["#3182CE", "#38A169", "#ECC94B", "#ED8936", "#E53E3E"]}
                          arcWidth={0.3}
                          percent={displayBmi? Math.min(displayBmi / 45, 1) : 0}
                          textColor={displayBmiColor}
                          needleColor="#2D3748"
                          needleBaseColor="#2D3748"
                          formatTextValue={() => displayBmi? displayBmi.toFixed(1) : '-'}
                          style={{ width: '100%', height: 'auto' }}
                          textComponentFontSize={24}
                          animate={true}
                          animDelay={0}
                        />
                        <Flex justify="space-between" fontSize={{ base: "2xs", sm: "xs" }} color="gray.500" mt={-2} px={{ base: 2, md: 4 }}>
                          <Text>15</Text>
                          <Text>18.5</Text>
                          <Text>25</Text>
                          <Text>30</Text>
                          <Text>40</Text>
                          <Text>45</Text>
                        </Flex>
                      </Box>
                      <Flex justify="center" mt={3}>
                        <Badge
                          fontSize={{ base: "sm", md: "md" }}
                          px={{ base: 3, md: 4 }}
                          py={1}
                          bg={displayBmiColor}
                          color="white"
                        >
                          {displayBmiCategory || 'Tidak ada data'}
                        </Badge>
                      </Flex>
                      <Text fontSize={{ base: "xs", sm: "sm" }} textAlign="center" color="gray.600" mt={2}>
                        {displayWeight}kg / {displayHeight}cm - {selectedDate}
                        {!selectedData?.weight && lastWeightHeight.tanggal && (
                          <Text as="span" fontSize="xs" color="orange.500"> *data {lastWeightHeight.tanggal}</Text>
                        )}
                      </Text>
                      {displayBmi >= 30 && (
                        <Alert status="warning" mt={4} borderRadius="md" fontSize={{ base: "xs", sm: "sm" }}>
                          <AlertIcon />
                          <Box>
                            <AlertTitle fontSize={{ base: "sm", md: "md" }}>Perhatian!</AlertTitle>
                            <AlertDescription fontSize={{ base: "xs", sm: "sm" }}>
                              BMI kamu {displayBmi.toFixed(1)} pada {selectedDate} masuk kategori {displayBmiCategory}. Risiko kesehatan meningkat.
                            </AlertDescription>
                          </Box>
                        </Alert>
                      )}
                      {displayBmi >= 25 && displayBmi < 30 && (
                        <Alert status="info" mt={4} borderRadius="md" fontSize={{ base: "xs", sm: "sm" }}>
                          <AlertIcon />
                        


                          <Box>
                            <AlertTitle fontSize={{ base: "sm", md: "md" }}>Info</AlertTitle>
                            <AlertDescription fontSize={{ base: "xs", sm: "sm" }}>
                              BMI kamu {displayBmi.toFixed(1)} pada {selectedDate} masuk kategori Overweight.
                            </AlertDescription>
                          </Box>
                        </Alert>
                      )}
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} className="chart-container">
                      <Text fontWeight="bold" mb={2}>Skor Kesehatan - {selectedDate}</Text>
                      <Flex align="center" gap={3}>
                        <Text fontSize="3xl" fontWeight="bold" color={`${displayHealthScore.color}.500`}>
                          {displayHealthScore.persen}
                        </Text>
                        <Badge colorScheme={displayHealthScore.color} fontSize="md">
                          {displayHealthScore.label}
                        </Badge>
                      </Flex>
                      <Progress value={displayHealthScore.persen} colorScheme={displayHealthScore.color} mt={2} borderRadius="md" />
                    </GridItem>
                  </Grid>

                  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" colSpan={{ base: 1, lg: 2 }} className="chart-container">
                    <Text fontWeight="bold" mb={3} textAlign="center">Perbandingan vs Standar WHO - {selectedDate}</Text>
                    <ResponsiveContainer width="100%" height={{ base: 350, md: 400 }}>
                      <BarChart
                        data={healthDetail}
                        layout="vertical"
                        margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" horizontal={false} opacity={0.2} />
                        <XAxis type="number" domain={[0, 100]} tickFormatter={(v) => `${v}%`} />
                        <YAxis dataKey="indikator" type="category" width={60} fontSize={12} />
                        <Tooltip
                          formatter={(v, name, props) => [
                            `${v}% (${props.payload.nilai}${props.payload.satuan})`,
                            name
                          ]}
                        />
                        <Legend />
                        <Bar dataKey="target" fill="#38A169" name="Target WHO" radius={[0, 4, 4, 0]} barSize={12} />
                        <Bar dataKey="aktual" fill="#3182CE" name="Skor Kamu" radius={[0, 4, 4, 0]} barSize={12} />
                      </BarChart>
                    </ResponsiveContainer>

                    <SimpleGrid columns={{ base: 1, md: 3 }} spacing={2} mt={4}>
                      {healthDetail.map(item => (
                        <Flex key={item.indikator} justify="space-between" p={2} bg={item.aktual >= 100? 'green.50' : item.aktual >= 60? 'orange.50' : 'red.50'} rounded="md">
                          <Text fontSize="sm" fontWeight="bold">{item.indikator}</Text>
                          <Badge colorScheme={item.aktual >= 100? 'green' : item.aktual >= 60? 'orange' : 'red'}>
                            {item.aktual}% / {item.nilai}{item.satuan}
                          </Badge>
                        </Flex>
                      ))}
                    </SimpleGrid>
                  </GridItem>


{/* CARD SARAN OTOMATIS */}
{(() => {
  const suggestion = generateSuggestion(mealVariant);
  if (!suggestion) return null;

  return (
    <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6} mt={6}>

      {/* Card Meal Plan */}
      <GridItem bg={cardBg} p={4} rounded="lg" shadow="md">
        <Flex align="center" justify="space-between" mb={3}>
          <Flex align="center" gap={2}>
            <Icon as={FaUtensils} color="orange.500" />
            <Text fontWeight="bold">Saran Meal Plan</Text>
          </Flex>
  <Button
  size="xs"
  colorScheme="orange"
  variant="outline"
  onClick={handleChangeMealVariant}
>
  Ganti Menu {mealVariant + 1}/3
</Button>
        </Flex>

        <Flex justify="space-between" align="center" mb={3}>
          <Text fontSize="sm">Target: <b>{suggestion.targetKalori} kkal</b></Text>
          <Badge colorScheme={suggestion.kategori === 'normal'? 'green' : suggestion.kategori === 'underweight'? 'blue' : 'red'}>
            {suggestion.kategori.toUpperCase()}
          </Badge>
        </Flex>

        <Flex gap={2} mb={4}>
          <Box flex={1} bg="whiteAlpha.500" p={2} rounded="md" textAlign="center">
            <Text fontSize="xs" color="gray.600">Protein</Text>
            <Text fontWeight="bold">{suggestion.makro.protein}g</Text>
          </Box>
          <Box flex={1} bg="whiteAlpha.500" p={2} rounded="md" textAlign="center">
            <Text fontSize="xs" color="gray.600">Karbo</Text>
            <Text fontWeight="bold">{suggestion.makro.karbo}g</Text>
          </Box>
          <Box flex={1} bg="whiteAlpha.500" p={2} rounded="md" textAlign="center">
            <Text fontSize="xs" color="gray.600">Lemak</Text>
            <Text fontWeight="bold">{suggestion.makro.lemak}g</Text>
          </Box>
        </Flex>

        <Stack spacing={2}>
          {suggestion.mealPlan.map((meal, idx) => (
            <Box key={idx} p={2} bg="whiteAlpha.400" rounded="md">
              <Flex justify="space-between">
                <Text fontSize="sm" fontWeight="600">{meal.waktu}</Text>
                <Text fontSize="sm" color="orange.600">{meal.kkal} kkal</Text>
              </Flex>
              <Text fontSize="xs" color="gray.700" mt={1}>{meal.menu}</Text>
            </Box>
          ))}
        </Stack>
        <Text fontSize="sm" textAlign="right" mt={2} fontWeight="bold">
          Total: {suggestion.totalKkal} kkal
        </Text>
      </GridItem>

      {/* Card Activity Plan - tetap sama */}
      <GridItem bg={cardBg} p={4} rounded="lg" shadow="md">
        <Flex align="center" gap={2} mb={3}>
          <Icon as={FaDumbbell} color="blue.500" />
          <Text fontWeight="bold">Saran Aktivitas</Text>
        </Flex>

        <Stack spacing={3}>
          {suggestion.activityPlan.map((act, idx) => (
            <Flex key={idx} gap={2} align="start">
              <Text color="blue.500" fontWeight="bold">•</Text>
              <Text fontSize="sm">{act}</Text>
            </Flex>
          ))}
        </Stack>

        <Alert status="info" mt={4} borderRadius="md" fontSize="xs">
          <AlertIcon />
          <Text>
            Saran berdasarkan WHO. Pantau berat 2 minggu. Kalau meleset, adjust kalori ±200 kkal.
          </Text>
        </Alert>
      </GridItem>
    </Grid>
  );
})()}








{/* GRAFIK HISTORY DARI MYSQL */}
<Text fontSize="xl" fontWeight="bold" mt={4}>History dari Database</Text>
<Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
  {/* 1. GRAFIK BMI HISTORY */}
  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
    <Text fontWeight="bold" mb={3}>History BMI - {jumlahHari} Hari Terakhir</Text>
    <ResponsiveContainer width="100%" height={300}>

<LineChart data={historyData}>
  <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
  <XAxis dataKey="tanggal" fontSize={10} interval={'preserveStartEnd'} />
  <YAxis 
    domain={[15, 40]} 
    ticks={[15, 18.5, 25, 30, 40]}
    tickFormatter={(v) => v.toFixed(1)} 
  />
  <Tooltip 
    formatter={(v, name, props) => [
      `${parseFloat(v).toFixed(1)} - ${props.payload.bmi_category}`, 
      'BMI'
    ]}
    labelFormatter={(label) => `Tanggal: ${label}`}
  />
  <Legend />
  <Line 
    type="monotone" 
    dataKey="bmi" 
    stroke="#E53E3E" 
    strokeWidth={3} 
    dot={{ r: 3, fill: '#E53E3E' }} 
    name="BMI" 
    connectNulls={true}
  />
  <ReferenceLine y={18.5} stroke="#3182CE" strokeDasharray="5 5" label={{ value: "Underweight", position: "insideTopLeft", fontSize: 10 }} />
  <ReferenceLine y={25} stroke="#38A169" strokeDasharray="5 5" label={{ value: "Normal", position: "insideTopLeft", fontSize: 10 }} />
  <ReferenceLine y={30} stroke="#ED8936" strokeDasharray="5 5" label={{ value: "Overweight", position: "insideTopLeft", fontSize: 10 }} />
</LineChart>
      
    </ResponsiveContainer>
  </GridItem>

  {/* 2. GRAFIK HEALTH SCORE HISTORY */}
  <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
    <Text fontWeight="bold" mb={3}>History Skor Kesehatan - {jumlahHari} Hari Terakhir</Text>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={historyData}>
        <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
        <XAxis dataKey="tanggal" fontSize={11} />
        <YAxis domain={[0, 100]} />
        <Tooltip formatter={(v, name, props) => [`${v} - ${props.payload.health_label}`, 'Skor']} />
        <Bar dataKey="health_score" name="Skor" radius={[4, 4, 0, 0]}>
          {historyData.map((entry, index) => {
            let color = '#E53E3E';
            if (entry.health_score >= 80) color = '#38A169';
            else if (entry.health_score >= 60) color = '#319795';
            else if (entry.health_score >= 40) color = '#DD6B20';
            return <Cell key={`cell-${index}`} fill={color} />;
          })}
        </Bar>
        <ReferenceLine y={80} stroke="#38A169" strokeDasharray="5 5" />
        <ReferenceLine y={60} stroke="#319795" strokeDasharray="5 5" />
        <ReferenceLine y={40} stroke="#DD6B20" strokeDasharray="5 5" />
      </BarChart>
    </ResponsiveContainer>
  </GridItem>
</Grid>

<SimpleGrid columns={{ base: 1, lg: 2, xl: 3 }} spacing={6}></SimpleGrid>




                  <SimpleGrid columns={{ base: 1, lg: 2, xl: 3 }} spacing={6}>
 <ChartCard title="Energi Dikeluarkan" dataKey="energi" name="Kalori" unit="kkal" icon={FaFire} />
   <ChartCard title="Jarak" dataKey="jarak_km" name="Jarak" unit="km" icon={FaRoute} />
   <ChartCard title="Menit Bergerak" dataKey="menit_bergerak" name="Menit" unit="menit" icon={FaRunning} />
   <ChartCard title="Menit Aktif" dataKey="menit_aktif" name="Poin" unit="poin" icon={FaHeart} />
 </SimpleGrid>
                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Aktivitas: step_count & Menit Aktif</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="step_count" fill="#3182CE" name="step_count" />
                          <Bar dataKey="menit_aktif" fill="#38A169" name="Menit Aktif" />
                        </BarChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Poin Kardio {jumlahHari} Hari Terakhir</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis />
                          <Tooltip />
                          <Bar dataKey="poin_kardio" fill="#38B2AC" name="Poin Kardio" />
                        </BarChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Kalori Masuk vs Keluar</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis />
                          <Tooltip />
                          <Legend />
                          <Line type="monotone" dataKey="calories_in" stroke="#ED8936" name="Kalori Masuk" />
                          <Line type="monotone" dataKey="energi" stroke="#E53E3E" name="Kalori Keluar" />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>


                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Durasi Tidur</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis tickFormatter={(v) => `${Math.round(v/60)}j`} />
                          <Tooltip formatter={(v) => `${Math.floor(v/60)}j ${v%60}m`} />
                          <Bar dataKey="sleepMinutes" fill="#805AD5" name="Durasi Tidur" />
                        </BarChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Berat Badan</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis domain={['dataMin - 5', 'dataMax + 5']} tickFormatter={(v) => `${v} kg`} />
                          <Tooltip formatter={(v) => `${v} kg`} />
                          <Line type="monotone" dataKey="weight" stroke="#9F7AEA" name="Berat (kg)" strokeWidth={2} dot={{ r: 4 }} connectNulls={true} isAnimationActive={false} />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Detak Jantung & Air Minum</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis yAxisId="left" />
                          <YAxis yAxisId="right" orientation="right" />
                          <Tooltip />
                          <Legend />
                          <Line yAxisId="left" type="monotone" dataKey="heart_rate" stroke="#D53F8C" name="Detak Jantung" />
                          <Line yAxisId="right" type="monotone" dataKey="water" stroke="#00B5D8" name="Air (Liter)" />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>
                  </Grid>

                  <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={6}>
                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md">
                      <Text fontWeight="bold" mb={3}>Denyut Istirahat & Saturasi Oksigen</Text>








               
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis yAxisId="left" domain={[40, 100]} tickFormatter={(v) => `${v} bpm`} />
                          <YAxis yAxisId="right" orientation="right" domain={[90, 100]} tickFormatter={(v) => `${v}%`} />
                          <Tooltip />
                          <Legend />
                          <Line yAxisId="left" type="monotone" dataKey="resting_heart_rate" stroke="#E53E3E" name="Istirahat (bpm)" dot={false}  />
                          <Line yAxisId="right" type="monotone" dataKey="oxygen_saturation" stroke="#3182CE" name="Oksigen (%)" dot={false} />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>

                    <GridItem bg={cardBg} p={4} rounded="lg" shadow="md" className="chart-container">
                      <Text fontWeight="bold" mb={3}>Gula Darah</Text>
                      <ResponsiveContainer width="100%" height={250}>
                        <LineChart data={historyData}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="tanggal" />
                          <YAxis domain={['dataMin - 10', 'dataMax + 10']} tickFormatter={(v) => `${v} mg/dL`} />
                          <Tooltip formatter={(v) => `${v} mg/dL`} />
                          <Line type="monotone" dataKey="blood_glucose" stroke="#DD6B20" name="Gula Darah" strokeWidth={2} dot={{ r: 3 }} connectNulls={true} />
                        </LineChart>
                      </ResponsiveContainer>
                    </GridItem>
                  </Grid>

                </Stack>
              ) : (
                <Flex h="calc(100vh - 64px)" bg={colorMode === "light" ? "white" : "gray.800"} alignItems="center" justifyContent="center" p={4}>
                  <Box
                    bgImage="url(/bg-health4.jpg)"
                    bgSize="cover"
                    bgPosition="center"
                    bgRepeat="no-repeat"
                    p={{ base: 6, md: 10 }}z
                    rounded="2xl"
                    shadow="2xl"
                    textAlign="center"
                    maxW="600px"
                    w="100%"
                    position="relative"
                    overflow="hidden"
                  >
                    <Box position="absolute" top={0} left={0} right={0} bottom={0} bg="rgba(255,255,255,0.6)" />
                    <Box position="relative" zIndex={1}>
                      <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color="gray.800" mb={3}>
                        Selamat Datang di Klinik Bugarin Tracker
                      </Text>
                      <Text fontSize="md" color="gray.700" mb={6}>
                        Klik "Connect Server Klinik Bugarin" untuk mulai pantau aktivitas dan kesehatanmu
                      </Text>
  <Button colorScheme="blue" variant="solid" size="sm" onClick={onLoginOpen}>
   Login Bugarin Tracker
 </Button>
                    </Box>
                  </Box>
                </Flex>
              )}
            </Flex>
          </Flex>
             {/* MODAL PASSWORD */}
 <Modal isOpen={isLoginOpen} onClose={onLoginClose} isCentered>
             <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(10px)" />
             <ModalContent>
               <ModalHeader>
                 <Flex align="center" gap={2}>
                   <Icon as={FaLock} color="blue.500" />
                   <Text>Login Bugarin Tracker</Text>
                 </Flex>
               </ModalHeader>
               <ModalCloseButton />
               <ModalBody pb={6}>
                 <Stack spacing={4}>
                   <FormControl isInvalid={!!loginError}>
                     <FormLabel>Email</FormLabel>
                     <Input
                       type="email"
                       placeholder="masukan@email.com"
                       value={loginEmail}
                       onChange={(e) => {
                         setLoginEmail(e.target.value);
                         setLoginError('');
                       }}
                     />
                   </FormControl>
                   <FormControl isInvalid={!!loginError}>
                     <FormLabel>Password</FormLabel>
                     <InputGroup>
                       <Input
                         type={showLoginPassword ? 'text' : 'password'}
                         placeholder="Password..."
                         value={loginPassword}
                         onChange={(e) => {
                           setLoginPassword(e.target.value);
                           setLoginError('');
                         }}
                         onKeyPress={(e) => e.key === 'Enter' && handleLoginMySQL()}
                       />
                       <InputRightElement width="4.5rem">
                         <Button h="1.75rem" size="sm" onClick={() => setShowLoginPassword(!showLoginPassword)}>
                           {showLoginPassword ? 'Hide' : 'Show'}
                         </Button>
                       </InputRightElement>
                     </InputGroup>
                     {loginError && <Text color="red.500" fontSize="sm" mt={1}>{loginError}</Text>}
                   </FormControl>
                 </Stack>
               </ModalBody>
               <ModalFooter>
                 <Button variant="ghost" mr={3} onClick={onLoginClose}>Batal</Button>
                 <Button colorScheme="blue" onClick={handleLoginMySQL} isLoading={loginLoading}>Login</Button>
               </ModalFooter>
             </ModalContent>
           </Modal>
 
           {/* Modal Password kirim data */}
           <Modal isOpen={isPasswordOpen} onClose={onPasswordClose} isCentered>
             {/* ...modal password kamu... */}
           </Modal>        </Box>
      )}
    </>
  );
};

const Dashboard = () => (
  <GoogleOAuthProvider clientId="">
    <DashboardContent />
  </GoogleOAuthProvider>
);

export default DashboardContent;